import { block, getJmapClient } from "./client";

let cachedByAccount = new Map<string, string>();

export async function getDefaultIdentityId(accountId: string): Promise<string> {
  const cached = cachedByAccount.get(accountId);
  if (cached) return cached;

  const client = getJmapClient();
  const res = await client.call([
    ["Identity/get", { accountId, ids: null, properties: ["id", "email"] }, "ig"],
  ]);
  const list = block<{ list?: { id: string }[] }>(res, "Identity/get").list ?? [];
  const id = list[0]?.id;
  if (!id) throw new Error("No sending identity configured for this account");
  cachedByAccount.set(accountId, id);
  return id;
}

export function clearIdentityCache(): void {
  cachedByAccount.clear();
}
